<template>
  <div class="summaryForm">
    <div>
      <b-card>
        <div style="font-size: 12px">
          <div class="title">
            <span>Cadastro de Responsáveis </span>
            <!-- <b-icon-info-circle style="color: gray" scale="1.2" /> -->
          </div>

          <div class="rowContainer">
            <span>
              <b-icon-person-lines-fill></b-icon-person-lines-fill>
              Informações Gerais</span
            >

            <div class="rowContent notBetween">
              <div style="flex: 1 1 40%; min-width: 200px">
                <Input
                  label="Nome"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.nome"
                  :isInvalidInput="invalidFields?.nome || ''"
                  @clearInvalidInput="clearInvalidFields('nome')"
                  ref="nome"
                />
              </div>

              <div style="flex: 1; min-width: 140px">
                <InputCpf
                  label="CPF"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.cpf"
                  :isInvalidInput="invalidFields?.cpf || ''"
                  @clearInvalidInput="clearInvalidFields('cpf')"
                  ref="cpf"
                />
              </div>

              <div style="flex: 1 1 20%; min-width: 140px">
                <Input
                  label="Profissão"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.profissao"
                  ref="profissao"
                />
              </div>

              <div class="contentInputEmail">
                <Input
                  label="Email"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.email"
                  :isInvalidInput="invalidFields?.email || ''"
                  ref="email"
                />
              </div>

              <div class="contentInputPhone">
                <InputPhone
                  label="Telefone"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.telefone"
                  ref="telefone"
                  isRemoveSpecialCharacters
                />
              </div>

              <div class="contentInputPhone">
                <InputPhone
                  label="celular"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.celular"
                  mask="(##) #####-####"
                  ref="celular"
                />
              </div>
            </div>
          </div>

          <div class="rowContainer">
            <span>
              <b-icon-geo-alt-fill></b-icon-geo-alt-fill> Localização</span
            >
            <div class="rowContent notBetween">
              <div class="contentInputCep">
                <InputCep
                  label="CEP"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.cep"
                  :clickBtnCep="fetchCep"
                  :isInvalidInput="invalidFields?.cep || ''"
                  @clearInvalidInput="clearInvalidFields('cep')"
                  ref="cep"
                />
              </div>

              <div style="flex: 1%; min-width: 200px">
                <Input
                  class="input-group-md"
                  label="Endereço"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.endereco"
                  :isInvalidInput="invalidFields?.endereco || ''"
                  @clearInvalidInput="clearInvalidFields('endereco')"
                  ref="endereco"
                />
              </div>

              <div style="flex: 1; min-width: 180px">
                <Input
                  label="Bairro"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.bairro"
                  :isInvalidInput="invalidFields?.bairro || ''"
                  @clearInvalidInput="clearInvalidFields('bairro')"
                  ref="bairro"
                />
              </div>

              <div class="contentInputNumber">
                <Input
                  class="input-group-sm"
                  label="Numero"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.numero"
                  :isInvalidInput="invalidFields?.numero || ''"
                  @clearInvalidInput="clearInvalidFields('numero')"
                  ref="numero"
                />
              </div>

              <div class="contentInputCity">
                <Input
                  label="cidade"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.cidade"
                  :isInvalidInput="invalidFields?.cidade || ''"
                  @clearInvalidInput="clearInvalidFields('cidade')"
                  ref="cidade"
                />
              </div>

              <div class="contentInputUF">
                <InputSelect
                  class="w-100"
                  label="UF"
                  valueField="value"
                  textField="text"
                  :items="ufs"
                  :dataSelect.sync="responsible.uf"
                  :enableIconCreate="false"
                  :dataInput="responsible.uf"
                  :isInvalidInput="invalidFields?.uf || ''"
                  @clearInvalidInput="clearInvalidFields('uf')"
                  ref="uf"
                />
              </div>
            </div>

            <div class="rowContent notBetween" style="margin-top: 10px">
              <div class="contentInputCity">
                <Input
                  label="IBGE"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.ibge"
                  ref="ibge"
                />
              </div>
            </div>
          </div>
          <div class="rowContainer">
            <span>
              <b-icon-file-earmark-text-fill /> Informações para receita</span
            >
            <div class="rowContent notBetween">
              <div class="contentInputNumberOfPrescription">
                <Input
                  label="Quant. receita"
                  type="number"
                  :labelFixed="true"
                  :dataInput.sync="responsible.quantidadeReceita"
                  :isInvalidInput="invalidFields?.quantidadeReceita || ''"
                  @clearInvalidInput="clearInvalidFields('quantidadeReceita')"
                  ref="quantidadeReceita"
                />
              </div>

              <div class="contentInputPrescriptionNumber">
                <Input
                  label="Nº Prox Receita"
                  type="number"
                  :labelFixed="true"
                  :dataInput.sync="responsible.receita"
                  :isInvalidInput="invalidFields?.receita || ''"
                  @clearInvalidInput="clearInvalidFields('receita')"
                  ref="receita"
                />
              </div>

              <div class="contentInputArtTrt">
                <Input
                  label="Nº ART / TRT Atual"
                  type="text"
                  :labelFixed="true"
                  :dataInput="responsible.art"
                  @update:dataInput="handleArtInput"
                  :isInvalidInput="invalidFields?.art || ''"
                  @clearInvalidInput="clearInvalidFields('art')"
                  ref="art"
                />
              </div>

              <div style="flex: 1; min-width: 160px">
                <Input
                  label="Complemento Receita"
                  type="text"
                  :labelFixed="true"
                  :dataInput.sync="responsible.complementoReceita"
                  ref="complementoReceita"
                />
              </div>
            </div>
          </div>
          <div
            class="rowContainer"
            :style="`${isFixed && !responsible.id && 'margin-bottom: 5rem'}`"
          >
            <span> <b-icon-info-circle-fill /> Outras Informações</span>

            <div>
              <div class="rowContent notBetween">
                <div style="flex: 1 1 15%; min-width: 100px">
                  <InputSelect
                    class="w-100"
                    label="Conselho"
                    valueField="value"
                    textField="text"
                    :items="advice"
                    :dataSelect.sync="responsible.conselho"
                    :enableIconCreate="false"
                    :dataInput="responsible.conselho"
                    ref="conselho"
                  />
                </div>

                <div class="contentInputCrea">
                  <Input
                    label="Nº Registro CREA / CFTA"
                    type="text"
                    :labelFixed="true"
                    :dataInput.sync="responsible.creaCfta"
                    ref="creaCfta"
                  />
                </div>

                <div style="flex: 1 1 20%">
                  <Input
                    label="Serie SC"
                    type="text"
                    :labelFixed="true"
                    :dataInput.sync="responsible.serieSC"
                    ref="serieSC"
                  />
                </div>

                <div style="flex: 1 1 20%">
                  <Input
                    label="Token SC"
                    type="text"
                    :labelFixed="true"
                    :dataInput.sync="responsible.tokenSC"
                    ref="tokenSC"
                  />
                </div>

                <div style="flex: 1 1 70%">
                  <Input
                    label="Observações"
                    type="text"
                    :labelFixed="true"
                    :dataInput.sync="responsible.observacao"
                    ref="observacao"
                  />
                </div>

                <div style="flex: 1; min-width: 100px">
                  <InputSelect
                    class="w-100"
                    label="Status"
                    valueField="value"
                    textField="text"
                    :items="status"
                    :dataSelect.sync="responsible.status"
                    :dataInput="responsible.status"
                    :enableIconCreate="false"
                    ref="status"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            :style="`${isFixed && 'margin-bottom: 5rem'}`"
            v-if="responsible.id"
          >
            <div class="rowContainer containerCertificate">
              <span>
                <b-icon-file-earmark-arrow-up-fill></b-icon-file-earmark-arrow-up-fill>
                Certificado</span
              >

              <div v-if="isLoadingCert" class="contentLoading">
                <b-spinner label="Spinning" class="loading" />
              </div>

              <div v-else>
                <div
                  class="rowContent"
                  v-if="!responsible.certUrl || isEnableUpdateCertificate"
                >
                  <div
                    style="
                      width: 100%;
                      display: flex;
                      align-items: center;
                      gap: 1rem;
                      flex-wrap: wrap;
                    "
                  >
                    <div class="contentInputFile">
                      <label
                        for="inputFile"
                        class="labelInputFile"
                        @dragover="handleDragOver"
                        @drop="handleDrop($event)"
                      >
                        <span class="textSelectFile">
                          <b-icon-paperclip scale="1.5" />
                          <p class="m-0 p-0">Escolha seu certificado</p>
                        </span>
                        <span class="textDropFile">{{ getNameFile() }}</span>
                      </label>

                      <input
                        type="file"
                        id="inputFile"
                        name="inputFile"
                        @change="handleFileChange($event)"
                        accept=".pfx"
                      />
                    </div>

                    <div style="width: 100%">
                      <InputPassword
                        label="Senha"
                        :labelFixed="true"
                        :dataInput.sync="dataCertificate.password"
                        style="width: 100%"
                      />
                    </div>

                    <div class="contentBtnsCertificate">
                      <div>
                        <b-button
                          class="btnGeneral btnSendCertificate"
                          size="sm"
                          @click="sendCertificate"
                          >Carregar Certificado</b-button
                        >
                      </div>

                      <div v-if="responsible.certUrl">
                        <b-button
                          class="btnGeneral btnCancel"
                          size="sm"
                          @click="cancelUpdateCertificate"
                          >Cancelar</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="rowContent rowCertificate" v-else>
                  <div style="width: 100%">
                    <div class="containerCertificateExpiration">
                      <b-icon-check2-circle scale="1.6" />

                      <div class="contentCertificateExpiration">
                        <span>Certificado vinculado </span>
                        <p v-if="certificateExpirationTime !== null">
                          Dias para vencimento:
                          {{ certificateExpirationTime }}
                        </p>
                      </div>
                    </div>

                    <div class="btnsUpdateCertificate">
                      <div style="display: flex; flex-direction: column">
                        <p style="margin: 0">Atualizar Certificado</p>
                        <p
                          style="
                            margin: 0;
                            font-size: 0.65rem;
                            color: #094a42bc;
                          "
                        >
                          Faça upload de um novo certificado
                        </p>
                      </div>

                      <div>
                        <b-button
                          class="btnUpdateCert"
                          @click="enableSendCertificate"
                          >{{ responsible.id ? "Atualizar" : "Salvar" }}
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="invalidPayloadText" class="rowCotent mt-2">
                  <p style="color: #e01515; font-size: 13px">
                    {{ invalidPayloadText }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>

    <div
      class="btnsContainer"
      :style="`${
        isFixed &&
        'position: fixed; box-shadow: -2px -2px 4px 0 rgba(0, 0, 0, 0.102);'
      }`"
    >
      <b-button class="btnsSaveNeutral" @click="clearInputs"
        >Novo <b-icon-arrow-clockwise class="ml-1"></b-icon-arrow-clockwise
      ></b-button>
      <b-button class="btnsSave" @click="saveOrUpdate"
        >{{ responsible.id ? "Atualizar" : "Salvar" }}
        <b-icon-person-check class="ml-1"></b-icon-person-check
      ></b-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { DateTime } from "luxon";
import api from "../../services/axios";

import Input from "../../components/UI/CustomInputs/Input.vue";
import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue";
import InputPhone from "../../components/UI/CustomInputs/InputPhone.vue";
import InputCpf from "../../components/UI/CustomInputs/InputCpf.vue";
import InputCep from "../../components/UI/CustomInputs/InputCep.vue";
import InputPassword from "../../components/UI/CustomInputs/InputPassword.vue";

import ServiceResponsible from "../../services/serviceResponsible";

import {
  INITIAL_STATE_RESPONSIBLE,
  INVALID_FIELDS_RESPONSIBLE,
} from "../../initialStates/responsible";
import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import { handleCpfOrCnpj } from "../../utils/validateCpfCnpj";
import { removeReference } from "../../utils/removeReference";
import { convertFileToBase64 } from "../../utils/convertFileToBase64";
import { ValidateResponsible } from "../../validators/responsible";
import { ufs } from "../../common";

import whatsapp from "../../assets/whatsapp.svg";

export default {
  props: {
    clearAll: {
      type: Boolean,
    },
    isFixed: {
      type: Boolean,
      default: true,
    },
    idResponsibleFromSearch: {
      type: String,
      default: "",
    },
  },
  components: {
    Input,
    InputSelect,
    InputPhone,
    InputCpf,
    InputCep,
    InputPassword,
  },
  data() {
    return {
      whatsapp: whatsapp,
      responsible: removeReference(INITIAL_STATE_RESPONSIBLE),
      spinGeneralCnpj: false,
      consumidorFinal: [
        { value: "0", text: "0 - Normal" },
        { value: "1", text: "1 - Consumidor final" },
      ],
      status: [
        { value: "ativo", text: "Ativo" },
        { value: "inativo", text: "Inativo" },
      ],
      spinGeneral: false,
      ufs: ufs,
      advice: [
        { text: "Selecione...", value: "" },
        { text: "CREA", value: "CREA" },
        { text: "CFTA", value: "CFTA" },
      ],
      invalidFields: removeReference(INVALID_FIELDS_RESPONSIBLE),
      certificateExpirationTime: null,
      isEnableUpdateCertificate: false,
      fileName: null,
      isLoadingCert: false,
      invalidPayloadText: "",
      dataCertificate: {
        base64: null,
        password: null,
      },
    };
  },

  methods: {
    ...mapMutations([
      "SET_DATA_SEARCH_FROM_RESPONSIBLE",
      "SET_IS_SEARCH_REGISTERS",
    ]),
    handleArtInput(value) {
      const art = value.trimStart();
      this.responsible.art = art;
      this.$refs.art.valueInput = art;
    },
    clearInputs() {
      this.responsible = removeReference(INITIAL_STATE_RESPONSIBLE);
      this.invalidFields = removeReference(INVALID_FIELDS_RESPONSIBLE);
      this.SET_DATA_SEARCH_FROM_RESPONSIBLE({});

      this.clearRefs();
    },

    clearRefs() {
      Object.keys(INITIAL_STATE_RESPONSIBLE).forEach((key) => {
        if (this.$refs[key] && this.$refs[key]?.valueInput)
          this.$refs[key].valueInput = "";
        else if (this.$refs[key] && this.$refs[key]?.valueItems)
          this.$refs[key].valueItems = key === "status" ? "ativo" : "";
      });
    },

    async saveOrUpdate() {
      if (typeof this.responsible.art === "string") {
        this.responsible.art = this.responsible.art.trim();
      }

      if (!this.handleValidateResponsible()) {
        return;
      }

      this.responsible.id === "" ? await this.save() : await this.update();

      this.SET_IS_SEARCH_REGISTERS();
      this.SET_DATA_SEARCH_FROM_RESPONSIBLE({});
    },

    async save() {
      try {
        const isValid = handleCpfOrCnpj(this.responsible.cpf, this.$toast);
        if (isValid && !isValid.isValid) {
          return isValid.alert();
        }

        const result = await ServiceResponsible.save(this.responsible);
        this.responsible.id = result.id;

        this.$emit("getAllResponsibles");
        this.clearInputs();
        return this.$toast.open({
          message: "Responsável salvo com Sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
      }
    },

    async update() {
      try {
        const result = handleCpfOrCnpj(this.responsible.cpf, this.$toast);
        if (result && !result.isValid) {
          return result.alert();
        }

        await ServiceResponsible.update(this.responsible, this.responsible.id);

        this.$emit("getAllResponsibles");
        this.clearInputs();
        this.$toast.open({
          message: "Responsável atualizado com Sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
      }
    },

    async fetchCnpj(cnpj) {
      try {
        this.spinGeneralCnpj = true;
        const formatedCnpj = cnpj.replace(/\D/g, "");
        const data = await api.get(
          `https://brasilapi.com.br/api/cnpj/v1/${formatedCnpj}`
        );

        if (data.data.nome_fantasia) {
          this.responsible.nome = data.data.nome_fantasia;
        } else {
          this.responsible.nome = data.data.razao_social;
        }
        this.responsible.endereco = data.data.logradouro;
        this.$refs.endereco = data.data.logradouro;

        this.responsible.numero = data.data.numero;
        this.$refs.numero = data.data.numero;

        this.responsible.bairro = data.data.bairro;
        this.$refs.bairro = data.data.bairro;

        this.responsible.cidade = data.data.municipio;
        this.$refs.cidade = data.data.municipio;

        this.responsible.uf = data.data.uf;
        this.$refs.uf = data.data.uf;
      } catch (error) {
        this.$toast.open({
          message:
            "Ocorreu um erro ao buscar as informações , verifique o CNPJ e tente novamente",
          type: "info",
        });
      } finally {
        this.spinGeneralCnpj = false;
      }
    },

    async findById(id) {
      return await ServiceResponsible.findById(id);
    },

    async fetchCep() {
      try {
        this.spinGeneral = true;
        const formatedCep = this.responsible.cep.replace(/\D/g, "");
        const data = await api.get(
          `https://brasilapi.com.br/api/cep/v1/${formatedCep}`
        );

        this.responsible.endereco = data.data.street;
        this.responsible.bairro = data.data.neighborhood;
        this.responsible.cidade = data.data.city;
        this.responsible.uf = data.data.state;
        this.responsible.ibge = data.data?.ibge?.city;

        this.$refs.endereco.valueInput = data.data.street;
        this.$refs.bairro.valueInput = data.data.neighborhood;
        this.$refs.cidade.valueInput = data.data.city;
        this.$refs.uf.valueItems = data.data.state;
      } catch (error) {
        this.$toast.open({
          message:
            "Ocorreu um erro ao buscar as informações , verifique o CEP e tente novamente",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    async handleModalCreateResponsible() {
      const responsible = await this.findById(this.idResponsibleFromSearch);
      this.SET_DATA_SEARCH_FROM_RESPONSIBLE(responsible);
      Object.assign(this.responsible, this.dataSearchResponsible);
      this.updateCertificateExpirationTime();
    },

    handleValidateResponsible() {
      const isNotValid = ValidateResponsible(this.responsible);
      return this.handleValidates(isNotValid);
    },

    handleValidates(errors) {
      if (errors && errors.length) {
        errors.forEach((erro) => {
          this.invalidFields[erro.keyError] = "isInvalidInput";
        });

        this.$toast.open({
          message: "Existem campos obrigatórios!",
          type: "info",
        });

        return false;
      }

      return true;
    },

    clearInvalidFields(key) {
      if (this.invalidFields[key]) this.invalidFields[key] = "";
    },

    async sendCertificate() {
      try {
        if (!this.valdatePayloadCertificate()) {
          return;
        }

        await ServiceResponsible.uploadCert(
          this.responsible.id,
          this.dataCertificate
        );

        const responsible = await ServiceResponsible.findById(
          this.responsible.id
        );
        Object.assign(this.responsible, responsible);
        this.updateCertificateExpirationTime();

        this.isEnableUpdateCertificate = false;
        this.invalidPayloadText = "";
        return this.$toast.open({
          message: "Certificado carregado com sucesso!",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            error.response.data.message || "Erro ao carregar o certificado",
          type: "info",
        });
      }
    },

    cancelUpdateCertificate() {
      this.isEnableUpdateCertificate = false;
      this.invalidPayloadText = "";
    },

    handleDragOver(event) {
      event.preventDefault();
    },

    async handleDrop(event) {
      event.preventDefault();

      const file = event.dataTransfer.files[0];
      if (!file) return;

      this.dataCertificate.base64 = await convertFileToBase64(file);
      this.fileName = file.name;
    },

    async handleFileChange(event) {
      this.dataCertificate.base64 = await convertFileToBase64(
        event.target.files[0]
      );
      this.fileName = event.target.files[0].name;
    },

    valdatePayloadCertificate() {
      if (!this.dataCertificate.base64) {
        this.invalidPayloadText = "* Certificado deve ser selecionado!";
        return false;
      } else if (!this.dataCertificate.password) {
        this.invalidPayloadText = "* Senha do certificado deve ser preenchida!";
        return false;
      }

      return true;
    },

    enableSendCertificate() {
      this.isEnableUpdateCertificate = true;
    },

    updateCertificateExpirationTime() {
      const expirationDate = DateTime.fromSQL(
        this.responsible.dataVencimentoCert || "",
        { zone: "America/Sao_Paulo" }
      );

      this.certificateExpirationTime = expirationDate.isValid
        ? Math.ceil(expirationDate.diffNow("days").days)
        : null;
    },

    getNameFile() {
      if (this.fileName) {
        return this.fileName;
      }

      return "Ou arraste e solte aqui";
    },
  },
  watch: {
    clearAll() {
      this.clearInputs();
    },
    getResponsibleId() {
      if (this.dataSearchResponsible.id) {
        Object.assign(this.responsible, this.dataSearchResponsible);
        this.updateCertificateExpirationTime();

        Object.keys(this.responsible).forEach((key) => {
          const currentValue = this.responsible[key];

          const newKey = key === "desconto" ? "discountItem" : key;
          if (this.$refs[newKey] && "valueInput" in this.$refs[newKey])
            this.$refs[newKey].valueInput = currentValue;
          else if (this.$refs[key] && "valueItems" in this.$refs[key])
            this.$refs[key].valueItems = currentValue;
        });
      }
    },
  },
  computed: {
    ...mapState(["dataSearchResponsible"]),
    maskcpf() {
      if (this.responsible.cpf === null) {
        return "";
      }
      if (this.responsible.cpf.length <= 14) {
        return "###.###.###-##";
      }
      if (this.responsible.cpf.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    },
    maskCep() {
      return "#####-###";
    },
    isInputLengthValid() {
      if (this.responsible.cpf) return this.responsible.cpf.length === 18;

      return false;
    },
    getResponsibleId() {
      return this.dataSearchResponsible.id;
    },
  },
  created() {
    if (this.dataSearchResponsible.id) {
      Object.assign(this.responsible, this.dataSearchResponsible);
      this.updateCertificateExpirationTime();
    } else if (this.idResponsibleFromSearch) {
      this.handleModalCreateResponsible();
    }
  },
  beforeDestroy() {
    this.clearInputs();
    this.SET_DATA_SEARCH_FROM_RESPONSIBLE({});
  },
};
</script>

<style scoped>
.summaryForm {
  display: flex;
  flex-direction: column;
  color: #006256;
}

.summaryForm label {
  margin-bottom: 0px;
  font-weight: bold;
}

.btnBack {
  border-radius: 5px;
  background-color: #006256;
  border: none;
  margin-top: 30px;
  color: white;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 13px;
  width: 150px;
  font-size: 18px;
  margin-top: 0;
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: rgb(213, 213, 213);
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: context-menu;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.bcsCep {
  display: flex;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}

.validRed {
  font-size: 13px;
  color: red;
}

.user-label-ob {
  position: absolute;
  left: 40px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.validRed::before {
  color: blue;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 8.9px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 14px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  justify-content: space-between;
}

.title span {
  font-weight: 600;
}

.contentInputCep {
  flex: 1 1 20%;
  min-width: 120px;
  max-width: 120px;
}

.contentInputPhone {
  flex: 1 1 20%;
  min-width: 160px;
  max-width: 200px;
}

.contentInputCity {
  flex: 1 1 15%;
  min-width: 180px;
  max-width: 200px;
}

.contentInputNumber {
  flex: 1 1 10%;
  min-width: 50px;
  max-width: 100px;
}

.contentInputCrea {
  flex: 1 1 15%;
  max-width: 220px;
  min-width: 140px;
}

.contentInputEmail {
  flex: 1 1 20%;
  min-width: 180px;
  max-width: 300px;
}

.contentInputUF {
  flex: 1;
  min-width: 60px;
  max-width: 0;
}

.contentInputPrescriptionNumber {
  flex: 1;
  min-width: 100px;
  max-width: 130px;
}

.contentInputNumberOfPrescription {
  flex: 1;
  min-width: 120px;
  max-width: 150px;
}

.contentInputArtTrt {
  flex: 1;
  min-width: 150px;
  max-width: 200px;
}

.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 60px;
  padding-left: 5px;
  border: solid 1px #d9d9d9;
  resize: none;
}

.requiredFields {
  font-size: 11px;
  color: red;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 5px;
}

.rowContainer span {
  font-weight: 600;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1.5rem;
}

.notBetween {
  justify-content: flex-start !important;
}

.rowObservation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 10px 0 5px 0;
}

.btnsContainer {
  gap: 20px;
  display: flex;
  width: calc(100% - 60px);
  justify-content: space-between;
  background-color: white;
  bottom: 0;
  left: 60px;
  z-index: 200;
  padding: 0.7% 32px;
}

.btnsSave {
  border-radius: 5px;
  background-color: #006256;
  width: 165px;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #d7d7d7;
  width: 165px;
  border: none;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 1rem 0 1rem;
}

.card {
  border: none !important;
}

.btnGeneral {
  border-radius: 5px;
  background-color: whitesmoke;
  width: 165px;
  border: none;
  color: rgb(29, 120, 21);
  font-size: 12px;
  border: 1px solid rgb(29, 120, 21);
}

.btnGeneral:hover {
  background-color: rgb(233, 255, 223);
  color: rgb(29, 120, 21);
}

/* -------------- CERTIFICATION -------------- */
.rowCertificate {
  justify-content: center;
}

.containerCertificateExpiration {
  display: flex;
  align-items: center;
  gap: 1rem;
  border-radius: 5px;
  border: solid 1px rgba(128, 128, 128, 0.34);
  border-radius: 8px;
  padding: 1rem;
  background-color: #00800014;
  width: 100%;
  margin-bottom: 0.65rem;
}

.containerCertificate {
  max-width: 420px;
}

.contentLoading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
}

.loading {
  width: 100px;
  height: 100px;
}

.contentCertificateExpiration {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  font-size: 0.75rem;
}

.contentCertificateExpiration span {
  font-weight: normal;
  color: #094a42;
}

.contentCertificateExpiration p {
  font-weight: normal;
  font-size: 0.65rem;
  margin: 0;
  color: #094a42bc;
}

.btnsUpdateCertificate {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  border-radius: 8px;
  background-color: white;
  width: 100%;
  color: black;
  font-size: 12px;
  border: solid 1px rgba(128, 128, 128, 0.34);
}

.btnUpdateCert {
  border-radius: 5px;
  border: none;
  background-color: white;
  color: rgb(0, 0, 0);
  font-size: 12px;
  border: solid 1px rgba(128, 128, 128, 0.34);
  transition: ease-in all 0.1s;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.178);
}

.btnUpdateCert:hover {
  background-color: #d7d7d743;
  color: rgb(0, 0, 0);
  outline: none;
  border: solid 1px rgba(128, 128, 128, 0.34);
  transition: ease-in all 0.1s;
}

/* -------------- CERTIFICATION -------------- */

/* INPUT FILE */

.contentBtnsCertificate {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.contentInputFile {
  display: flex;
  gap: 5px;
  align-items: center;
}

input[type="file"] {
  display: none;
}

.labelInputFile {
  width: 400px;
  min-width: 400px;
  display: flex;
  align-items: center;
  gap: 5px;
  border: dashed 1px #c1c1c1;
  border-radius: 5px;
  cursor: pointer !important;
  margin: 0;
}

.textSelectFile {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 0;
  background-color: #c1c1c156;
  border-radius: 5px;
  font-weight: bold;
  font-size: 11px;
  padding: 5.75px 9px;
  cursor: pointer;
}

.textSelectFile p {
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
}

.textDropFile {
  max-width: 230px !important;
  overflow: hidden;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: normal;
  cursor: pointer;
}

/* INPUT FILE */

@media screen and (max-width: 400px) {
  .contentInputPhone,
  .contentInputEmail,
  .contentInputCep,
  .contentInputNumber,
  .contentInputUF,
  .contentInputCity,
  .contentInputArtTrt,
  .contentInputNumberOfPrescription,
  .contentInputPrescriptionNumber {
    max-width: 100%;
  }
}

@media screen and (max-width: 700px) {
  .rowContent {
    display: flex;
    width: 100%;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    gap: 1rem;
    /* flex-direction: column; */
  }

  .input-group {
    width: 100% !important ;
  }
}

@media screen and (max-width: 750px) {
  .containerCertificate,
  .contentInputFile,
  .labelInputFile {
    width: 100%;
    min-width: 100%;
  }
}

@media screen and (max-width: 430px) {
  .contentBtnsCertificate div,
  .btnSendCertificate,
  .btnCancel {
    width: 100% !important;
  }

  .contentBtnsCertificate {
    gap: 1rem;
  }
}
</style>
